export const ApplicationModule = Object.freeze({
	Default: "Default",
	Internship: "Internship",
	Freelance: "Freelance",
	AccountSetting: "AccountSetting",
	GALKLab: "GALKLab",
});
